var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"product-reason"},_vm._l((_vm.product.rejectReasons),function(reasons,i){return _c('li',{key:i},[_vm._v(" "+_vm._s(reasons)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }